export default "__VITE_ASSET__a3080897__"